import { MinusIcon } from '@radix-ui/react-icons';
import { Box, Card, Flex, Heading, IconButton, Text } from '@radix-ui/themes';
import React, { useEffect } from 'react';
import { Control } from 'react-hook-form';
import DateFieldComponent from '../../components/inputs/Datefield/DatefieldComponent';
import RadioGroupComponent from '../../components/inputs/RadioGroup/RadioGroupComponent';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { AssessmentType } from '../../types/Assessment';
import { SubjectType } from '../../types/Subject';

interface IProps {
    index: number;
    remove: any;
    control: Control<AssessmentType>;
    errors: any;
    setValue?: any;
    getValues?: any;
    watch: any;
    subject?: SubjectType;
}

export const Assessment: React.FC<IProps> = ({
    index,
    remove,
    control,
    errors,
    watch,
    subject,
    setValue
}) => {
    const watchExamType = watch(`assessments.${index}.examType`);
    const watchAssessmentType = watch(`assessments.${index}.type`);

    useEffect(() => {
        if (watchExamType) {
            setValue(`assessments.${index}.type`, watchExamType);
        }
        else {

        }
    }, [watchExamType]);

    useEffect(() => {
        const isExam = watchAssessmentType?.includes('Exame');
        if (isExam) {
            setValue(`assessments.${index}.examType`, watchAssessmentType);
        } else {
            setValue(`assessments.${index}.examType`, '');
        }
    }, [watchAssessmentType]);

    return (
        <Card size='2' style={{ padding: '20px', marginBottom: '16px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
            <Flex direction='column' gap='4'>
                <Flex align='center' justify='between'>
                    <Heading size='2' weight='bold'>Avaliação {index + 1}</Heading>
                    <IconButton
                        color='red'
                        size='2'
                        onClick={(e: any) => {
                            e.preventDefault();
                            remove(index);
                        }}
                    >
                        <MinusIcon width="18" height="18" />
                    </IconButton>
                </Flex>

                <Flex gap='4' direction='column'>
                    <Box>
                        <TextFieldComponent
                            name={`assessments.${index}.type`}
                            label="Tipo de Avaliação"
                            control={control}
                            errors={errors}
                            fieldProps={{
                                placeholder: 'Ex: Prova escrita, Teste prático'
                            }}
                            style={{ width: '100%' }}
                        />
                        {errors?.assessments?.[index]?.type && (
                            <Text color="red" size="1">{`${errors.assessments[index]?.type?.message}`}</Text>
                        )}
                    </Box>

                    {subject?.hasExam && (
                        <Box>
                            <RadioGroupComponent
                                name={`assessments.${index}.examType`}
                                label=''
                                control={control}
                                errors={errors}
                                options={[
                                    { value: 'Exame Normal', label: 'Exame Normal' },
                                    { value: 'Exame de Recorrência', label: 'Exame de Recorrência' },
                                    { value: 'Exame Especial', label: 'Exame Especial' },
                                ]}
                                fieldProps={{
                                    style: { display: 'flex', flexDirection: 'row', gap: '16px' },
                                }}
                            />
                        </Box>
                    )}

                    <Box>
                        <TextFieldComponent
                            name={`assessments.${index}.weight`}
                            label="Peso (%)"
                            control={control}
                            errors={errors}
                            fieldProps={{
                                placeholder: 'Ex: 40',
                                type: 'number'
                            }}
                            style={{ width: '100%' }}
                        />
                        {errors?.assessments?.[index]?.weight && (
                            <Text color="red" size="1">{`${errors?.assessments[index]?.weight?.message}`}</Text>
                        )}
                    </Box>
                    
                    <Box>
                        <DateFieldComponent
                            name={`assessments.${index}.date`}
                            label="Data de realização"
                            control={control}
                            errors={errors}
                            style={{ width: '25%' }}
                        />
                        {errors?.assessments?.[index]?.date && (
                            <Text color="red" size="1">{`${errors?.assessments[index]?.date?.message}`}</Text>
                        )}
                    </Box>
                </Flex>
            </Flex>
        </Card>
    );
};